import * as api from '@/api';

export default {
    data() {
        return {
            workOrder: {
                client: null,
                name: null,
                address: null,
                city: null,
                state: null,
                zip: null,
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                dumpSite: null,
                loadSite: null,
                rateType: 'hourly',
                hourlyRate: null,
                notes: null,
                hourlyRateOptions: {
                    precheckTime: false,
                    mobilizationTime: false,
                    standbyTime: false,
                    demobilizationTime: false,
                    postcheckTime: false,
                },
                materialRates: [],
                materials: [],
                sites: [],
                isSitesEnabled: false,
                mobilizationPrice: null,
                demobilizationPrice: null,
                reportTimeOverrides: {
                    precheckTime: null,
                    mobilizationTime: null,
                    standbyTime: null,
                    demobilizationTime: null,
                    postcheckTime: null,
                },
                tags: {},
            },

            submitPending: false,
            submitError: null,
        };
    },

    methods: {
        async createWorkOrder() {
            if (!this.$refs.workOrderForm.validate()) {
                return;
            }

            this.submitPending = true;
            this.submitError = null;

            const company = this.$store.state.company.id;
            const res = await api.createWorkOrder({ ...this.workOrder, company });

            this.submitPending = false;

            if (res.error) {
                this.submitError = res.error.message;
                this.$awn.alert('Failed to create work order');
                return null;
            }

            this.submitError = null;
            this.$awn.success('New work order added');

            this.$store.dispatch('company/fetchOverview');

            return res.body;
        },
    },
};
